// mvp-returns — client for the full returns module at /ord/returns/* on
// de-order-service. Replaces the retired /inv/returns (de-invoice-service)
// endpoints, whose accept skipped the warehouse-receipt gate and state machine.

import { v4 as uuidv4 } from "uuid";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

// Every return state-mutation route wraps in `withStrictIdempotency`, which 400s
// (RET-002) without an Idempotency-Key header. A fresh uuid v4 per call gives each
// logical mutation its own key while letting genuine client retries replay safely.
const idem = (): Record<string, string> => ({ "Idempotency-Key": uuidv4() });

// Routes wrapped in `requireIfMatch` read the optimistic-lock version from the
// `If-Match` header (RET-090 without it). `!= null` so version 0 is sent, not dropped.
const ifMatch = (v?: number): Record<string, string> => (v != null ? { "If-Match": String(v) } : {});

export const ReturnsApi = {
  create: async (data: any) => {
    return httpRequest.post("/ord/returns", data, idem());
  },
  list: async (params?: any) => {
    return httpRequest.get("/ord/returns", params);
  },
  // Нийлүүлэгчийн агуулахууд (propose дахь targetWarehouseId сонгогч).
  warehouses: async () => {
    return httpRequest.get("/ord/returns/warehouses");
  },
  get: async (id: string) => {
    return httpRequest.get(`/ord/returns/${id}`);
  },
  propose: async (id: string, data: any) => {
    return httpRequest.post(`/ord/returns/${id}/propose`, data, { ...idem(), ...ifMatch(data?.expectedVersion) });
  },
  accept: async (id: string, data?: any) => {
    return httpRequest.post(`/ord/returns/${id}/accept`, data || {}, { ...idem(), ...ifMatch(data?.expectedVersion) });
  },
  reject: async (id: string, data: any) => {
    return httpRequest.post(`/ord/returns/${id}/reject`, data, idem());
  },
  dispute: async (id: string, data: any) => {
    return httpRequest.post(`/ord/returns/${id}/dispute`, data, { ...idem(), ...ifMatch(data?.expectedVersion) });
  },
  cancel: async (id: string, data?: any) => {
    return httpRequest.post(`/ord/returns/${id}/cancel`, data || {}, { ...idem(), ...ifMatch(data?.expectedVersion) });
  },
};
